import React from "react";
import "./footer.scss";
import logo from "../../assets/logo.png";
import { GoDotFill } from "react-icons/go";

const Footer = () => {
  return (
    <div className="footer_main">
      <div className="logo_name">
        <div className="logo_div">
          <img src={logo} alt="highq.com logo" />
        </div>
        <div className="name_div">
          <h1>
            HIGH Q <br />
            CONSULTING
          </h1>
        </div>
      </div>
      <div className="navigation_menus">
        <nav>
          <a href="/">HOME</a>
          <a href="/about">ABOUT</a>
          <a href="/services">SERVICES</a>
          <a href="/partners">OUR PARTNERS</a>
          <a href="/contact">CONTACT US</a>
        </nav>
      </div>
      <div className="footer_end">
        <h6>&copy;2025 HIGH Q</h6>
        <GoDotFill className="dot" />
        <nav>
          <a href="/privacy">Privacy</a>
        </nav>
      </div>
    </div>
  );
};

export default Footer;
